<script>
    import { DateTime, Duration } from "luxon";

    export let fromTime = DateTime.local().startOf('hour').plus({hours: 1});
    export let duration = Duration.fromObject({ minutes: 30 })
    export let toTime = fromTime.plus(duration);

    const times = createTimeOptions();

    $: if(timeGTE(fromTime, toTime)) {
        toTime = fromTime.plus(duration);
    } else {
        duration = toTime.diff(fromTime, ['hours', 'minutes']);
    }

    function createTimeOptions() {
        let times = [];
        let time = DateTime.local().startOf('day');
        const tomorrow = time.plus({days: 1});

        while(time < tomorrow) {
            times.push(time);
            time = time.plus({minutes: 15});
        }

        return times;
    }

    function areSameTimes(left, right) {
        return left.hour == right.hour && left.minute == right.minute;
    }

    function timeLTE(left, right) {
        return left <= right;
    }

    function timeGTE(left, right) {
        return left >= right;
    }


</script>

<div class="main">
    <span class="time-select">
        <label for="from-select">From</label>
        <select name="from-select" bind:value={fromTime}>
            {#each times as time}
                <option 
                    value={time} 
                    selected={areSameTimes(time, fromTime)}
                >
                    {time.toLocaleString(DateTime.TIME_SIMPLE)}
                </option>
            {/each}
        </select>
    </span>
    <span class="time-select">
        <label for="to-select">To</label>
        <select name="to-select" bind:value={toTime}>
            {#each times as time}
                <option 
                    value={time} 
                    selected={areSameTimes(time, toTime)}
                    disabled={timeLTE(time, fromTime)}
                >
                    {time.toLocaleString(DateTime.TIME_SIMPLE)}
                </option>
            {/each}
        </select>
    </span>
    <span class="time-duration">
        {duration.hours > 0 ? duration.hours + " hrs.": ""} {duration.minutes > 0 ? duration.minutes + " mins.": ""}
    </span>
</div>

<style>
.main {
    max-width: 100%;
    margin: 0 auto 0 auto;
    padding: 1.0em;
}

.time-select {
    display: inline-block;
    padding: 0.5em;
}

.time-select select {
    background-color: white;
    box-sizing: border-box;
	margin: 0;
	border: 1px solid var(--blugry-main);
    border-radius: 8px;
    -moz-appearance: none;
	-webkit-appearance: none;
	appearance: none;
}

</style>